import React from 'react';
import { Link } from 'react-router-dom'; // ✅ Import Link
import './style.css';
import pet1 from '../images/pet-1.svg';
import pet2 from '../images/pet-2.svg';
import pet3 from '../images/pet-3.svg';
import pet4 from '../images/pet-4.svg';
import pet5 from '../images/pet-5.svg';

const pets = [
  { id: 16, name: 'Maltipoo', image: pet1 },
  { id: 17, name: 'Pug', image: pet2 },
  { id: 18, name: 'Beagle', image: pet3 },
  { id: 19, name: 'Golden Retriever', image: pet4 },
  { id: 20, name: 'Dachshund', image: pet5 },
];

const PetListings = () => {
  return (
    <section className="pet-listings">
      <h2>Trending Pet’s</h2>
      <div className="pet-grid">
        {pets.map((pet) => (
          <Link to={`/all-dog-breed`} key={pet.id} className="pet-card-link">
            <div className="pet-card">
              <img src={pet.image} alt={pet.name} />
              <h3>{pet.name}</h3>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
};

export default PetListings;
